import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnimalSelectionComponent } from './animal-selection.component';
import { Route, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';
import { PageLayoutModule } from '@tcc-mono/shared/ui/page-layout';
import { AnimalSelectionAnimalsModule } from '@tcc-mono/vandijk/shared/features/animal-selections/feature/animal-selection-animals';
import { AnimalSelectionDetailsModule } from '@tcc-mono/vandijk/shared/features/animal-selections/feature/animal-selection-details';
import { AnimalSelectionAnimalsComponent } from '@tcc-mono/vandijk/shared/features/animal-selections/feature/animal-selection-animals';
import { AnimalSelectionDetailsComponent } from '@tcc-mono/vandijk/shared/features/animal-selections/feature/animal-selection-details';

const routes: Route[] = [
  {
    path: '',
    component: AnimalSelectionComponent,
    children: [
      {
        path: 'details',
        component: AnimalSelectionDetailsComponent
      },
      {
        path: 'animals',
        component: AnimalSelectionAnimalsComponent
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'details'
      }
    ]
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    IonicModule,
    PageLayoutModule,
    TranslocoModule,
    FontAwesomeModule,
    AnimalSelectionDetailsModule,
    AnimalSelectionAnimalsModule
  ],
  declarations: [AnimalSelectionComponent]
})
export class AnimalSelectionModule {}
